<template>
  <CCard class="cursor p-0 mr-3">
    <CCardHeader class="p-0 position-relative">
      <image-view
        v-if="cmeDetails.event_image && cmeDetails.event_image.length"
        :src="cmeDetails.event_image"
        alt="CME image"
      />
      <image-view v-else :src="'/img/avatars/event-image.png'" alt="CME image" />
      <div class="status-div">
        <p
          v-if="!cmeDetails.is_published && cmeDetails.status === 'deleted'"
          class="reject mb-0"
        >Deleted</p>
        <p
          v-if="!cmeDetails.is_published && cmeDetails.status === 'pending'"
          class="approval-pending mb-0"
        >Approval Pending</p>
        <p
          v-if="!!cmeDetails.is_published && cmeDetails.status === 'published'"
          class="published mb-0"
        >
          <b>Published</b>
        </p>
        <p
          v-if="!cmeDetails.is_published && cmeDetails.status === 'unpublished'"
          class="unpublished mb-0"
        >Unpublished</p>
        <p
          v-if="!cmeDetails.is_published && cmeDetails.status === 'rejected'"
          class="reject mb-0"
        >Rejected</p>
        <p
          v-if="!cmeDetails.is_published && cmeDetails.status === 'expired'"
          class="reject mb-0"
        >Expired</p>
      </div>
    </CCardHeader>
    <CCardBody class="py-2">
      <h5 class="title text-capitalize">
        <b>{{ cmeDetails.event_name }}</b>
      </h5>
      <div class="d-just-space">
        <p class="mb-0 w-50 text-ellipsis text-capitalize">
          {{ cmeDetails.event_organizer }}
          <br />
          <b class="mt-1 d-block text-capitalize">{{ getDate(cmeDetails.event_date) }}</b>
        </p>
        <div class="d-flex w-50">
          <div class="organize-name w-100">
            <p class="text-ellipsis text-right text-capitalize">{{ cmeDetails.organization_name }}</p>
          </div>
        </div>
      </div>
      <div v-if="cmeDetails.status == 'published'" class="share-blog d-align cme-share-blog">
        <share-blogs type="cme" :slug="cmeDetails.slug"></share-blogs>
      </div>
      <div class="text d-flex">
        <div>
          <b class="fz-12 text-capitalize">Mode of Event:</b>
        </div>
        <div class="pl-3 eventmode">
          <p class="text-capitalize mb-0">{{ cmeDetails.event_mode }}</p>
        </div>
      </div>

      <div class="d-flex d-just-space xs-lg-flex-dir-col">
        <div class="text d-flex w-50 lg-w-100">
          <div>
            <b>Event Charges:</b>
          </div>
          <div class="pl-3 eventmode">
            <p class="text-capitalize mb-0">{{ cmeDetails.event_charge }}</p>
          </div>
        </div>
        <div class="text d-flex">
          <div>
            <b>Credit Points Applicable:</b>
          </div>
          <div class="pl-3 eventmode">
            <p v-if="!!cmeDetails.mmc_credit_points" class="mb-0">Yes</p>
            <p v-else class="mb-0">No</p>
          </div>
        </div>
      </div>

      <div
        class="text-capitalize m-0 mt-1 d-flex justify-content-space-bet align-items-center pt-2 pb-2"
      >
        <v-btn
          v-if="cmeDetails.status !== 'DRAFT'"
          @click="getCmeDetails()"
          text
          x-large
          color="success"
        >READ MORE</v-btn>
      </div>
    </CCardBody>
    <CCardFooter class="flex-end xs-flex-dir-col">
      <!-- APPROVAL BUTTON -->
      <span>
        <v-btn
          v-if="
            permissions.includes('CAN_PUBLISH_CME_LISTING') &&
            !cmeDetails.is_published &&
            cmeDetails.status === 'pending'
          "
          color="success  ml-2 mr-2 xs-width"
          @click="openSwal('publish')"
        >Approve & publish</v-btn>
      </span>

      <span>
        <v-btn
          v-if="
            permissions.includes('CAN_UNPUBLISH_CME_LISTING') &&
            !!cmeDetails.is_published &&
            cmeDetails.status === 'published'
          "
          color="success ml-2 mr-2  xs-width"
          @click="openUnpublishModal('unpublish')"
        >Unpublish</v-btn>
      </span>

      <span>
        <v-btn
          v-if="
            permissions.includes('CAN_PUBLISH_CME_LISTING') &&
            !cmeDetails.is_published &&
            cmeDetails.status === 'unpublished'
          "
          color="success  ml-2 mr-2 xs-width"
          @click="openSwal('publish')"
        >Publish</v-btn>
      </span>

      <span>
        <v-btn
          v-if="
            permissions.includes('CAN_REJECT_CME_LISTING') &&
            !cmeDetails.is_published &&
            cmeDetails.status === 'pending'
          "
          color="error xss-mt-5 xs-width"
          class="ml-2 mr-2"
          @click="openRejectModal()"
        >Reject</v-btn>
      </span>
    </CCardFooter>
    <CModal
      :show.sync="rejectModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Reason"
      size="lg"
      color="dark"
      class="reject-modal-box"
    >
      <CTextarea
        v-model="reasonData.rejected_reason"
        type="text"
        maxlength="150"
        label="Reason"
        name="reason"
        placeholder="Reason"
        horizontal
        rows="2"
      />
      <span
        v-if="reasonData.rejected_reason === '' && alert === true"
        class="text-danger required-fields"
      >{{ requiredAlert }}</span>

      <template #header>
        <h6 class="modal-title">Reason for Reject</h6>
      </template>

      <template #footer>
        <v-btn @click="rejectModal = false" class="btn btn-danger">Cancel</v-btn>
        <v-btn class="btn btn-success" @click="closeRejectModal()">Submit</v-btn>
      </template>
    </CModal>
    <CModal
      :show.sync="unpublishModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Reason"
      size="lg"
      color="dark"
      class="reject-modal-box"
    >
      <CTextarea
        v-model="reasonData.unpublishReason"
        type="text"
        maxlength="150"
        label="Reason"
        name="reason"
        placeholder="Reason"
        horizontal
        rows="2"
      />
      <span
        v-if="reasonData.unpublishReason === '' && alert"
        class="text-danger required-fields"
      >{{ requiredAlert }}</span>

      <template #header>
        <h6 class="modal-title">Reason for Unpublishing</h6>
      </template>

      <template #footer>
        <v-btn @click="unpublishModal = false" class="btn btn-danger">Cancel</v-btn>
        <v-btn class="btn btn-success" @click="closeUnpublishModal()">Submit</v-btn>
      </template>
    </CModal>
  </CCard>

  <!-- </div> -->
</template>

<script>
import Swal from "sweetalert2";
import config from "@/config.js";
import { mapGetters } from "vuex";
import "@/assets/scss/_blogs.scss";
const ShareBlogs = () => import("@/components/modals/shareBlog.vue");
const Image = () => import("@/components/image.vue");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  props: ["cmeDetails"],
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  components: {
    "image-view": Image,
    "share-blogs": ShareBlogs
  },
  data() {
    return {
      reasonData: {
        rejected_reason: "",
        unpublishReason: ""
      },
      rejectModal: false,
      reasonModal: false,
      unpublishModal: false,
      alert: false,
      requiredAlert: "This field is required.",
      dayJS,
      status: ""
    };
  },
  methods: {
    openRejectModal() {
      this.rejectModal = true;
    },
    openUnpublishModal() {
      this.unpublishModal = true;
    },
    closeUnpublishModal() {
      this.updateCME("unpublish");
      if (!alert) {
        this.unpublishModal = false;
      } else {
        this.unpublishModal = true;
      }
    },
    closeRejectModal() {
      if (!alert) {
        this.rejectModal = false;
      } else {
        this.rejectModal = true;
      }
      this.rejectCME("rejected");
    },
    getCmeDetails() {
      this.$router.push(`/cme-events/${this.cmeDetails.slug}`);
    },
    getDate(date) {
      return dayJS(date).format("Do MMMM YYYY");
    },

    updateCME(status) {
      let obj;
      if (status === "publish") {
        obj = {
          status: status
        };
      } else if (status === "unpublish") {
        if (this.reasonData.unpublishReason == "") {
          this.alert = true;
          return false;
        } else {
          obj = {
            status: status,
            reason: this.reasonData.unpublishReason
          };
        }
      } else {
        obj = {
          is_deleted: true
        };
      }
      let url = `${config.BASE_URL}api/v2/admin/cme-events/${this.cmeDetails._id}`;
      this.$http.put(url, obj).then(response => {
        if (!!response.ok) {
          if (status === "publish") {
            Swal.fire({
              title: "CME Event Published Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.$emit("refreshList");
              }
            });
          } else {
            Swal.fire({
              title: "CME Event Unpublished Successfully",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "Ok"
            }).then(result => {
              if (result.isConfirmed) {
                this.unpublishModal = false;
                this.$emit("refreshList");
              }
            });
          }
        }
      });
    },

    rejectCME(status) {
      if (this.reasonData.rejected_reason == "") {
        this.alert = true;
        return false;
      } else {
        let obj;
        if (status === "rejected") {
          obj = {
            status: status,
            reason: this.reasonData.rejected_reason
          };
        } else {
          obj = {
            is_deleted: true
          };
        }

        let url = `${config.BASE_URL}api/v2/admin/cme-events/${this.cmeDetails._id}`;
        this.$http.put(url, obj).then(response => {
          if (!!response.ok) {
            if (status === "rejected") {
              Swal.fire({
                title: "CME Event Rejected ",
                icon: "success",
                showCancelButton: false,
                confirmButtonText: "Ok"
              }).then(result => {
                if (result.isConfirmed) {
                  this.$emit("refreshList");
                  this.rejectModal = false;
                }
              });
            }
          }
        });
      }
    },
    openSwal(status) {
      if (status === "approve") {
        Swal.fire({
          title: "Are you sure you want to Approve and Publish this Event",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.updateCME(status);
          }
        });
      } else if (status === "publish") {
        Swal.fire({
          title: "Are you sure you want to Publish this Event",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }).then(result => {
          if (result.isConfirmed) {
            this.updateCME(status);
          }
        });
      }
    }
  }
};
</script>